module.exports = __webpack_public_path__ + "static/media/YM14_3.931583bd.jpg";